import React from 'react';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const ProfileComment = ({ Data, i18 }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>
        <div style={{ fontWeight: 'bold' }}>{i18.TIT_ABOUT}</div>
        <Paragraph style={{ textAlign: 'justify', marginBottom: 0 }}>
          {Data.about.details}
        </Paragraph>
      </div>
    </div>
  );
};

export default ProfileComment;
